import { defineMessages } from 'utils/intl';

export default defineMessages({
  header: 'Konfigurator Dell',
  description:
    'Oficjalny konfigurator serwerów i macierzy Dell. Skonfiguruj samodzielnie lub skorzystaj z naszej pomocy, a następnie zamów w oficjalnym kanale sprzedaży Dell. Miej pewność wyboru najlepszego rozwiązania i kontrolę nad całym procesem realizacji zamówienia. Na etapie wdrożenia możesz uzyskać pomoc naszego certyfikowanego zespołu inżynierów.',
});
